import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { WatchAwareComponent } from '../watch-aware.component';
import { Account } from 'src/sync/account';
import { Room } from 'src/sync/room';
import { Util } from 'src/util/util';
import { Toastbar } from 'src/util/toastbar';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    standalone: false
})
export class SettingsComponent extends WatchAwareComponent {
    @Output() complete = new EventEmitter<string>();

    constructor(
        public toastbar: Toastbar,
        public override changeDetectorRef: ChangeDetectorRef,
    ) { super(changeDetectorRef) }

    public loginName = Account.loginName;
    public username = Account.settings.get().name;
    public passwordInput = '';
    public openAiKey = Account.settings.get().openAiKey;
    public usercolor = `${Account.settings.get().color}`;
    public swapmiddleright = Account.settings.get().swapmiddleright;
    public requiredragselect = Account.settings.get().requiredragselect;
    public disablesfx = Account.settings.get().disableSFX;
    public quality = Account.settings.get().highquality;
    public opaquemacros = Account.settings.get().opaquemacros;
    public isOwner = Room.ownerId === Account.id;

    public showReload = false;

    public ngOnInit() {
        this.track(Account.settings.watch((account) => {
            this.quality = account.highquality;
            this.username = account.name;
            this.usercolor = account.color;
        }));
    }

    public throttle: any;
    public update() {
        // TODO: This is a terrible way of alerting the user to a problem and handling the problem.
        const clashingUser = Room.getAttendee(this.username);
        if (clashingUser && clashingUser.id != Account.id) {
            this.toastbar.open("Username must be unique", undefined, { duration: 1000, });
            return;
        }

        clearTimeout(this.throttle);
        this.throttle = setTimeout(() => {
            Account.settings.modify((account) => {
                account.name = Account.storeName(this.username || this.loginName);
                account.color = this.usercolor;
                account.swapmiddleright = this.swapmiddleright;
                account.requiredragselect = this.requiredragselect;
                account.disableSFX = this.disablesfx;
                account.opaquemacros = this.opaquemacros;
                account.openAiKey = this.openAiKey;
                Room.attendance.modify(Account.id, x => {
                    x.name = account.name;
                    x.color = this.usercolor;
                    this.changeDetectorRef.detectChanges();
                });
            });
        }, 500);
    }

    public toggleQuality() {
        Account.settings.modify(x => x.highquality = !x.highquality);
        this.showReload = true;
    }

    public reloadWindow() {
        window.location.reload();
    }

    public async changePassword() {
        const token = await Account.provider.getToken();
        const { userToken } = JSON.parse(token!);
        const response = await fetch(`${Util.roomUrl}/password`,
            {
                method: 'PUT',
                headers:
                    new Headers({
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${userToken}`
                    }),
                body: JSON.stringify({
                    "password": this.passwordInput,
                }),
            });

        if (response.ok) {
            this.toastbar.open("Room password changed successfully.", undefined, {
                duration: 1000,
            });
        } else {
            const errorText = await response.text();
            this.toastbar.open(errorText, undefined, {
                duration: 1000,
            });
        }
    }
}
